import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.entries";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import FallbackErrorPage from './fallbackErrorPage.vue';
import FallbackEmpty from './fallbackEmpty.vue';
import { logException } from '../../sentry';

var isObjectEmpty = function isObjectEmpty(obj) {
  return Object.entries(obj).length === 0 && obj.constructor === Object;
};

var warn = function warn(msg) {
  return console.warn(msg);
}; // https://github.com/posva/vue-promised/blob/master/src/index.js


var convertVNodeArray = function convertVNodeArray(h, wrapperTag, nodes) {
  // for arrays and single text nodes
  if (nodes.length > 1 || !nodes[0].tag) {
    return h(wrapperTag, {}, nodes);
  }

  return nodes[0];
};

export default {
  name: 'ErrorBoundary',
  props: {
    fallBack: {
      type: [Object, Boolean],
      default: function _default() {
        return FallbackErrorPage;
      }
    },
    onError: {
      type: Function,
      default: null
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    stopPropagation: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: 'span'
    }
  },
  data: function data() {
    return {
      err: '',
      info: '',
      hasError: null
    };
  },
  computed: {
    fallbackComponent: function fallbackComponent() {
      return this.fallBack ? this.fallBack : FallbackEmpty;
    }
  },
  errorCaptured: function errorCaptured(err, vm) {
    var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    this.hasError = true;
    this.err = err;
    this.info = info;
    this.element = vm.$vnode.tag; // Send error to Sentry

    logException(this.err, {
      level: 'fatal',
      tags: {
        boundary: true
      }
    });
    this.$emit('errorCaptured', {
      err: err,
      vm: vm,
      info: info
    });

    if (this.onError) {
      this.onError(err, vm, info);
    }

    if (this.stopPropagation) {
      return false;
    }
  },
  render: function render(h) {
    var fallback = this.fallbackComponent;
    var content = this.$slots.default;
    var isScoped = this.$scopedSlots.boundary;
    var scopedSlot;

    if (isScoped) {
      scopedSlot = this.$scopedSlots.boundary({
        hasError: this.hasError,
        err: this.err,
        info: this.info,
        element: this.element
      });
    }

    var fallbackOrScoped = isScoped ? scopedSlot : h(fallback, {
      props: _objectSpread(_objectSpread({}, this.params), {}, {
        error: this.err,
        info: this.info,
        element: this.element
      })
    });

    if (this.hasError) {
      return Array.isArray(fallbackOrScoped) ? convertVNodeArray(h, this.tag, fallbackOrScoped) : fallbackOrScoped;
    }

    if (isScoped) {
      if (!this.$scopedSlots.boundary()) {
        warn('ErrorBoundary component must have child components.');
        return null;
      }

      return Array.isArray(scopedSlot) ? convertVNodeArray(h, this.tag, scopedSlot) : scopedSlot;
    }

    if (isObjectEmpty(this.$slots)) {
      warn('ErrorBoundary component must have child components.');
      return null;
    }

    return Array.isArray(content) ? convertVNodeArray(h, this.tag, content) : content;
  }
};